module.exports = __webpack_public_path__ + "img/caret.d7be045a.svg";